import { MuiTheme } from "theme";
import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme: MuiTheme) => {
  const { text } = theme.palette;

  return {
    root: {
      backgroundColor: "#fff",
      borderRadius: 4,
      boxShadow: "0px 1px 7px 0px rgba(0, 0, 0, 0.1)"
    },
    stableEntry: {
      display: "flex",
      padding: "14px 14px 8px 14px",
      justifyContent: "space-between",
      alignItems: "center",
      height: 76
    },
    horseName: {
      fontSize: 16,
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      lineHeight: "24px",
      textTransform: "capitalize"
    },
    horseInfo: {
      display: "flex",
      alignItems: "center",
      fontSize: 12,
      color: text.secondary,
      lineHeight: "24px"
    },
    viewHorseDetail: {
      textDecoration: "underline",
      textTransform: "none",
      padding: 0,
      fontSize: 12,
      color: text.secondary,
      "&:hover": {
        backgroundColor: "transparent",
        textDecoration: "underline"
      }
    },
    checkboxes: {
      width: 86,
      display: "flex",
      justifyContent: "space-between"
    }
  };
});
